import { hasAuthority } from '@/utils/authority-utils'
import { loginIgnore } from '@/router/index'
import { checkAuthorization } from '@/utils/request'
import NProgress from 'nprogress'
import { setToken } from '@/utils/auth'
import loginWithToken from '@/api/user';
import baseApi from '@/api/base.js'
import env from '../../env/index';
import store from '../store/index'

NProgress.configure({ showSpinner: false })

async function afterLogin() {
  const res = await baseApi.getDictionary({
    status: 1,
    type: 'temp_public_customer',
  });
  const showTemperatureList = []
  res.forEach(item => {
    showTemperatureList.push(item.dictionaryCode)
  });
  localStorage.setItem('showTemperatureList', JSON.stringify(showTemperatureList))
  // todo 获取路由配置
  const { customerId, creditCode } = store.state.user
  if (!customerId && !creditCode) {
    return '/authentication'
  }
  return '/'
}
const toLogin = (next) => {
  if (process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'qa') {
    const loginUrl = localStorage.getItem('loginUrl') || env.LOGIN_URL;
    window.location = `${loginUrl}/#/login`;
  } else {
    next({ path: '/login' });
  }
};

const setShortToken = async (to, next) => {
  const { token, clientCode } = to.query;
  const data = {
    clientCode,
    extJson: {
      source: "ENTERPRISE_CUSTOMER",
      ignoreCreditCode: true
    }
  };
  setToken(token);
  try {
    console.log(to.query.isNoLogin, '!to?.query?.noLogin!to?.query?.noLogin!to?.query?.noLogin');
    if (!to?.query?.isNoLogin) {
      const loginUrl = (to.query && to.query.loginUrl) || env.LOGIN_URL;
      localStorage.setItem('loginUrl', loginUrl);
      const res = await loginWithToken(data);
      setToken(res.token);
      const ext = res.ext ? JSON.parse(res.ext) : null;
      await store.dispatch('user/login', { ...res, ext, type: 'unifyLogin', admin: res?.admin })
    } else {
      store.commit('iframe/SET_IS_NO_LOGIN', to.query.isNoLogin)
    }
    if (to?.query?.hiddenMenu && to?.query?.token) {
      store.commit('iframe/SET_IS_HIDDEN_MENU', true);
      setToken(to.query.token);
      let tokenPath = ''
      if (to.fullPath.includes('?token')) {
        tokenPath = to.fullPath.replace('?token', '?removeToken')
      } else {
        tokenPath = to.fullPath.replace('&token', '&removeToken')
      }
      if (to.query.source === 'workbench') {
        store.commit('iframe/SET_SOURCE_PATH', to.path)
      }else if (to.query.source === 'WMS') {
        store.commit('iframe/SET_SOURCE', to.query.source)
      }else if (to.query.source === 'onlyGpsPage') {
        store.commit('iframe/SET_SOURCE', to.query.source)
      }else {
        store.commit('iframe/SET_SOURCE', '')
      }
      next(tokenPath)
    } else {
      const path = await afterLogin()
      next(path)
    }
  } catch (e) {
    toLogin(next);
  }
};
/**
 * 进度条开始
 * @param to
 * @param form
 * @param next
 */
const progressStart = (to, from, next) => {
  // start progress bar
  if (!NProgress.isStarted()) {
    NProgress.start()
  }
  next()
}

/**
 * 登录守卫
 * @param to
 * @param form
 * @param next
 * @param options
 */
const loginGuard = async (to, from, next, options) => {
  const { message } = options
  if (to?.query?.token) {
    await setShortToken(to, next)
    // eslint-disable-next-line no-param-reassign
  } else if (!loginIgnore.includes(to) && !checkAuthorization()) {
    message.warning('登录已失效，请重新登录')
    next({ path: '/login' })
  } else {
    next()
  }
}

/**
 * 权限守卫
 * @param to
 * @param form
 * @param next
 * @param options
 */
const authorityGuard = (to, from, next, options) => {
  const { message } = options
  const permissions = store.getters['account/permissions']
  const roles = store.getters['account/roles']
  if (!hasAuthority(to, permissions, roles)) {
    message.warning(`对不起，您无权访问页面: ${to.fullPath}，请联系管理员`)
    next({ path: '/403' })
    // NProgress.done()
  } else {
    next()
  }
}

/**
 * 混合导航模式下一级菜单跳转重定向
 * @param to
 * @param from
 * @param next
 * @param options
 * @returns {*}
 */
const redirectGuard = (to, from, next) => {
  // todo 添加菜单跳转前的权限校验
  next()
}

/**
 * 进度条结束
 * @param to
 * @param form
 * @param options
 */
const progressDone = () => {
  // finish progress bar
  NProgress.done()
}

export default {
  beforeEach: [progressStart, loginGuard, authorityGuard, redirectGuard],
  afterEach: [progressDone]
}
